import { length, map, o, reduce } from 'ramda';

export const getColumnCount: (grid: unknown[][]) => number = o(reduce(Math.max, 0), map(length));
